import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';


//Redux
import { useSelector, useDispatch } from "react-redux";
import { setPersonalDetails } from 'src/redux/actions/user.actions';


import { gender, civilStatus, monthly } from 'src/utils/constants';


const AccountProfileDetails = (props) => {
  const { user } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.ui);

  const dispatch = useDispatch();
  const [values, setValues] = useState({
    firstName: '',
    lastName: '',
    middleName: '',
    email: '',
    gender: 'male',
    birthDate: null,
    occupation: '',
    monthlyIncome: '1',
    civilStatus: 'single'
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };


  const handleSubmit = () => {

      dispatch(setPersonalDetails(values))
      .then(a => {
      })
      .catch(err => {
        console.log(err)
      })
  }





  useEffect(() => {
    if(user && user.personalDetails){
      setValues({...values, ...user.personalDetails});
    }
  }, [user])


  return (
    <form
      autoComplete="off"
      noValidate
      {...props}
    >
      <Card>
        <CardHeader
          subheader="The information can be edited"
          title="Basic Infomration"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              md={4}
              xs={12}
            >
              <TextField
                fullWidth
                label="First name"
                name="firstName"
                onChange={handleChange}
                value={values.firstName}
                size="small"
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <TextField
                fullWidth
                label="Middle name"
                name="middleName"
                onChange={handleChange}
                value={values.middleName}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <TextField
                fullWidth
                label="Last name"
                name="lastName"
                onChange={handleChange}
                value={values.lastName}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
              <TextField
                fullWidth
                helperText="Date of Birth"
                name="birthDate"
                value={values.birthDate}
                onChange={handleChange}
                variant="outlined"
                size="small"
                type="date"
              />
            </Grid>
          
            <Grid
              item
              md={4}
              xs={12}
            >
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                value={values.email}
                onChange={handleChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
               <TextField
                fullWidth
                label="Gender"
                name="gender"
                onChange={handleChange}
                select
                SelectProps={{ native: true }}
                value={values.gender}
                variant="outlined"
                size="small"
              >
                {gender.map((option, index) => (
                  <option
                    key={index}
                    value={option.value}
                  >
                    {option.name}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
               <TextField
                fullWidth
                label="Occupation"
                name="occupation"
                value={values.occupation}
                onChange={handleChange}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid
              item
              md={4}
              xs={12}
            >
               <TextField
                fullWidth
                label="Civil Status"
                name="civilStatus"
                onChange={handleChange}
                select
                SelectProps={{ native: true }}
                value={values.civilStatus}
                variant="outlined"
                size="small"
              >
                {civilStatus.map((option, index) => (
                  <option
                    key={index}
                    value={option.value}
                  >
                    {option.name}
                  </option>
                ))}
              </TextField>
            </Grid>
          
            <Grid
              item
              md={4}
              xs={12}
            >
               <TextField
                fullWidth
                label="Monthly Income"
                name="monthlyIncome"
                onChange={handleChange}
                select
                SelectProps={{ native: true }}
                value={values.monthlyIncome}
                variant="outlined"
                size="small"
              >
                {monthly.map((option, index) => (
                  <option
                    key={index}
                    value={option.value}
                  >
                    {option.name}
                  </option>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
            disabled={loading}
            onClick={handleSubmit}
          >
            Save details
          </Button>
        </Box>
      </Card>
    </form>
  );
};

export default AccountProfileDetails;
